// @flow

import React from 'react';
import PropTypes from "prop-types";
import Tvalue from './Tvalue';

//import Legacy from '../Legacy';

const propTypes = {
	id: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    style: PropTypes.object,
    /**
     * Input välja väärtuse andmetüüp:
     * string - string
     * number - number (teisendatakse väärtus reaalarvuks ja tagasi)
     * integer - täisarv (teisendatakse väärtus täisarvuks ja tagasi)
     */
    valueType: PropTypes.string,
    valueDecimals: PropTypes.string,
    value: PropTypes.any,
    /**
     * onChange(onChangeParam, value)
     */
    onChange: PropTypes.func,
	onChangeParam: PropTypes.any,
	onEnter: PropTypes.func,
	disabled: PropTypes.bool
};

const defaultProps = {
	type: 'text',
	valueType: 'string',
	value: null,
	className: "smallinput",
	disabled: false
};


class Tinput extends Tvalue {
	
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onKeyUp = this.onKeyUp.bind(this);
	}
	
	componentWillReceiveProps(newProps) {
		let numValue = this.valueFromString(this.state.value);
		if (numValue !== newProps.value) {
			this.setState({
				value: this.valueToString(newProps.value),
				isValid: this.isValid(newProps.value)
			});
		}
	}
	
	onChange(e) {
		e.preventDefault();
		let isValid = this.isValid(e.target.value);
		if (this.props.onChange) {
			let value = this.valueFromString(e.target.value);
			this.setState({
				value: e.target.value,
				isValid: isValid
			},
			function () {
				this.props.onChange(this.props.onChangeParam, value);
			}.bind(this));
		} else {
			this.setState({
				value: e.target.value,
				isValid: isValid
			});
		}
	}
	
	onBlur(e) {
		e.preventDefault();
		let value = this.valueFromString(e.target.value);
		if (this.props.onChange) {
			this.props.onChange(this.props.onChangeParam, value);
		}
	}

	onKeyUp(e) {
		if (e.keyCode == 13 && this.props.onEnter) this.props.onEnter(e);
	}
	
	render() {
		let style = {};
		if (this.props.style) style = this.props.style;
		if (this.props.width) style.width = this.props.width;
		let classname = 'form-control';
		if (this.props.className) classname += ' ' + this.props.className;
		if (!this.state.isValid) classname += ' invalid';
		return (<input id={this.props.id}
					   type={this.props.type}
					   className={classname}
					   style={style}
					   value={this.state.value == null ? "" : this.state.value}
					   onBlur={this.onBlur}
					   onChange={this.onChange}
					   onKeyUp={this.props.onEnter == null ? null : this.onKeyUp}
					   disabled={this.props.disabled}
		/>);
	}
}

Tinput.propTypes = propTypes;
Tinput.defaultProps = defaultProps;

export default Tinput;
